<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-30 14:59:45
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-13 18:29:14
-->
<template>
  <el-radio-group :disabled="disabled" v-model="listIndex" @change="handleResult" class="x-radio">
    <el-radio v-for="(item, index) in listData" :key="index" :label="item[propObject.value]">
      {{ item[propObject.label] }}
      <!-- <slot :name="item.value"></slot> -->
    </el-radio>
  </el-radio-group>
</template>
<script>
  export default {
    name: 'XRadioGroup',
    model: {
      prop: 'result',
      event: 'handleResult'
    },
    props: {
      listData: {
        type: Array,
        default: () => []
      },
      propObject: {
        type: Object,
        default: () => {
          return { label: 'label', value: 'value' }
        }
      },
      result: [String, Number],
      disabled: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        listIndex: null
      }
    },
    computed: {
      getResult() {
        return this.result
      }
    },
    watch: {
      getResult(newValue) {
        if (newValue !== this.listIndex) {
          this.listIndex = newValue
        }
      }
    },
    mounted() {
      this.listIndex = this.result
    },
    methods: {
      handleResult() {
        this.$emit('handleResult', this.listIndex)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .x-radio {
    display: flex;
    align-items: center;
    height: 36px;
  }
</style>
